import { clsx, type ClassValue } from 'clsx';

/** Conditional className composition. Thin wrapper over clsx for ergonomics. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
